import {BackArrow, BackArrowIcon, HeaderDiv} from "./Styled";
import React from "react";
import {useHistory} from "react-router";

interface Props {
    placeholder: string;
}
const Header: React.FC<Props> = ({placeholder}: Props) => {
    const history = useHistory();
    return (
        <HeaderDiv>
            <BackArrow
                onClick={() => {
                    history.goBack();
                }}
            >
                <BackArrowIcon />
            </BackArrow>
            <p>{placeholder}</p>
        </HeaderDiv>
    );
};

export default Header;
